export function loadZapierJsAndCss(_ref) {
  let {
    injectScriptOrLink
  } = _ref;
  const script = document.createElement('script');
  script.id = 'zapier-elements-js';
  script.type = 'module';
  script.src = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js';
  const loadJSPromise = injectScriptOrLink(script);
  const stylesheet = document.createElement('link');
  stylesheet.id = 'zapier-elements-css';
  stylesheet.rel = 'stylesheet';
  stylesheet.href = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css';
  const loadCSSPromise = injectScriptOrLink(stylesheet);
  return Promise.all([loadJSPromise, loadCSSPromise]).then(() => null);
}